export default "__VITE_ASSET__yxnTFSgk__"